var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Vue, Component, Watch } from 'vue-property-decorator';
import { BOverlay, BFormRadioGroup, BRow, BCol, BFormGroup, BFormInput, BButton, BCard, BAlert } from 'bootstrap-vue';
import axios from 'axios';
import debounce from 'lodash/debounce';
import { DiscountsBreakdown } from 'vallatonvue';
import UnitSelector from 'components/UnitSelector.vue';
import SizeInput from 'components/SizeInput.vue';
import StandardSizeSelector from 'components/StandardSizeSelector.vue';
import UpsellSheetProduct from 'components/UpsellSheetProduct.vue';
import ProductDiscontinued from 'components/materials/ProductDiscontinued.vue';
import { addToCart } from 'ts/modules/cart';
import { validateSheet } from 'ts/modules/validation';
import { sheetDelivery } from 'ts/modules/delivery';
import { checkSheetStock } from 'ts/modules/stock';
import { getProductDiscounts, getSheetPrice } from 'ts/modules/pricing';
import { getVatMode, isAdmin } from 'ts/modules/helpers';
const urlParams = new URLSearchParams(window.location.search);
let Sheet = class Sheet extends Vue {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.loadingDiscounts = true;
        this.loadingPrice = true;
        this.loadingValidation = true;
        this.loadingStock = true;
        this.isAddingToCart = false;
        this.isAdmin = false;
        this.vatMode = 'inc';
        this.product = null;
        this.size = {
            width: parseInt(urlParams.get('widthMM') || '210'),
            length: parseInt(urlParams.get('lengthMM') || '297'),
            type: !urlParams.get('widthMM') ? 'a' : undefined,
            name: !urlParams.get('widthMM') ? 'A4' : undefined
        };
        this.quantity = 1;
        this.isInStock = true;
        this.validation = {
            problems: [],
            warnings: [],
            isValid: true
        };
        this.delivery = {
            problems: [],
            warnings: [],
            isValid: true
        };
        this.sizeType = urlParams.get('widthMM') ? 'bespoke' : 'standard';
        this.sizeTypeOptions = [
            { text: 'Custom Size', value: 'bespoke' },
            { text: 'Standard Size', value: 'standard' },
        ];
        this.displayUnit = 'mm';
        this.pricing = {
            base_unit_price: '0.00',
            ex_vat_base_unit_price: '0.00',
            unit_price: '0.00',
            total_price: '0.00',
            unit_discount: '0.00',
            total_discount: '0.00'
        };
        this.discounts = [];
        this.debouncedUpdated = debounce(this.update, 350);
    }
    get isValidQuantity() {
        return this.quantity > 0;
    }
    get isAddToCartDisabled() {
        return ((!this.validation.isValid || !this.isInStock) && !this.isAdmin)
            || !this.isValidQuantity
            || this.isAddingToCart;
    }
    get buyButtonVariant() {
        if (this.validation.problems.length > 0 || !this.isValidQuantity) {
            return 'danger';
        }
        else if (this.validation.warnings.length > 0) {
            return 'warning';
        }
        return 'success';
    }
    get areDimensionsValid() {
        return this.size.width > 0 && this.size.length > 0;
    }
    update() {
        if (!this.isValidQuantity) {
            return;
        }
        this.validate();
        this.updatePrice();
        this.checkStock();
    }
    validate() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.product || !this.product.sku) {
                return;
            }
            this.loadingValidation = true;
            this.validation = yield validateSheet(this.product.sku, this.size);
            this.delivery = yield sheetDelivery(this.product.sku, this.size);
            this.loadingValidation = false;
        });
    }
    updatePrice() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.product || !this.product.sku) {
                return;
            }
            this.loadingPrice = true;
            this.pricing = yield getSheetPrice(this.product.sku, this.size, false, null, this.quantity);
            this.loadingPrice = false;
        });
    }
    checkStock() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.product || !this.product.sku) {
                return;
            }
            this.loadingStock = true;
            this.isInStock = yield checkSheetStock(this.product.sku, this.size, this.quantity);
            this.loadingStock = false;
        });
    }
    addToCart() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.product || !this.product.sku) {
                return;
            }
            this.isAddingToCart = true;
            try {
                yield addToCart({
                    sku: this.product.sku,
                    qty: this.quantity,
                    attributes: {
                        "Size": `${this.size.width}x${this.size.length}mm`,
                        "Delivery Available": this.delivery.isValid.toString()
                    }
                }, false);
            }
            catch (e) {
                console.error(e);
            }
            this.isAddingToCart = false;
        });
    }
    getDiscounts() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.product) {
                return;
            }
            this.loadingDiscounts = true;
            this.discounts = yield getProductDiscounts(this.product.id, this.pricing.ex_vat_base_unit_price);
            this.loadingDiscounts = false;
        });
    }
    onSizeTypeChange() {
        if (this.sizeType == 'standard') {
            // Default the size to A4 rather than trying to match it up
            this.size = {
                width: 210,
                length: 297,
                name: 'A4',
                type: 'a'
            };
        }
        else if (this.sizeType == 'bespoke') {
            switch (this.size.type) {
                case 'inch':
                case 'square':
                    this.displayUnit = 'inch';
                    break;
                case 'cm':
                    this.displayUnit = 'cm';
                    break;
                case 'a':
                    this.displayUnit = 'mm';
                    break;
            }
            this.size = {
                width: this.size.width,
                length: this.size.length
            };
        }
    }
    mounted() {
        return __awaiter(this, void 0, void 0, function* () {
            // Get the product from the slug
            let slug = window.location.href.split('/').pop();
            if (slug) {
                let { data } = yield axios
                    .get('/api/accessories/productBySlug', { params: { slug: slug.replace(window.location.search, '') } });
                this.product = data;
                yield this.updatePrice();
                yield this.checkStock();
                yield this.getDiscounts();
            }
            this.loading = false;
        });
    }
    created() {
        this.vatMode = getVatMode();
        isAdmin()
            .then(isAdmin => this.isAdmin = isAdmin);
    }
};
__decorate([
    Watch('size', { deep: true }),
    Watch('quantity')
], Sheet.prototype, "debouncedUpdated", void 0);
__decorate([
    Watch('pricing.base_unit_price')
], Sheet.prototype, "getDiscounts", null);
Sheet = __decorate([
    Component({
        components: {
            BOverlay, BFormRadioGroup, BRow, BCol, BFormGroup, BFormInput, BButton, BCard, BAlert,
            DiscountsBreakdown,
            UnitSelector, SizeInput, StandardSizeSelector, UpsellSheetProduct, ProductDiscontinued
        }
    })
], Sheet);
export default Sheet;
